import { Callout } from '@/components/Callout';
import { useTranslation } from '@/i18n/useTranslation';

/**
 * The `Get help` block the openings list ends on [Figma `06 · Jobs` · 12055:10340 desktop · 10357 iPad ·
 * 10374 mobile, all three read 2026-09-02].
 *
 * It is the design system's brand `Callout` with the frame's `Action link` in its action slot — every value
 * comes from the node itself: `--primary-muted` on `--primary-muted-foreground`, `--radius-sm`, 16px
 * padding, an 8px gap between the text and the control, 14/20 text. The two sentences sit **10px** apart
 * rather than the callout's 8, because that distance is the text node's own `paragraphSpacing` and not an
 * item gap.
 *
 * **The control is INERT, exactly like `NeedHelpFab`.** Its destination is the help panel, which is KQA-1 /
 * KVE-1 and still `draft` — wiring it would mean inventing a screen that has no design and no approved
 * story. Rendering it disabled keeps the block the size the frame draws without promising a destination.
 *
 * **The copy is the frame's, word for word, in both languages** [Operator, 2026-09-02]. It is
 * candidate-facing copy ISS has not signed off — OQ-58 is owed by them — so it is theirs to replace, not
 * ours to improve.
 */
export function GetHelpCallout() {
  const t = useTranslation();

  return (
    <Callout
      action={
        /*
         * 46px tall — 20px of label inside 13px of vertical padding — which is what the frame's `Action
         * link` measures. Above the 44px touch floor, so the § 9 exception does not apply here.
         */
        <button
          aria-disabled="true"
          className="kiosk-focusable py-[13px] text-sm leading-5 text-[var(--link)] underline"
          disabled
          type="button"
        >
          {t('jobs.help.action')}
        </button>
      }
    >
      <span className="block">{t('jobs.help.title')}</span>
      <span className="mt-[10px] block">{t('jobs.help.body')}</span>
    </Callout>
  );
}
